import {isFeatureEnabled} from 'feature-flags';

import {featureFlags} from '@dms/feature-flags';
import {usePermissions} from '@dms/shared';

export function useCanCreateVehicleBlock() {
  const [hasEditRentalVehiclePermission] = usePermissions({
    permissionKeys: ['editRentalVehicle'],
  });

  return isFeatureEnabled(featureFlags.RENTAL_VEHICLE_BLOCKS) && hasEditRentalVehiclePermission;
}
